import request from '@/utils/request'

// 菜单树桩列表
export function cdListTree(query) {
  return request({
    url: '/sys/menu/listTree',
    method: 'get',
    params: query
  })
}

// 查询角色菜单
export function menuTree(query) {
  return request({
    url: '/sys/roleMenu/menuTree',
    method: 'get',
    params: query
  })
}

// 配置角色菜单
export function cfgMenu(data) {
  return request({
    url: '/sys/roleMenu/cfgMenu',
    method: 'post',
    data
  })
}

// 编辑菜单/保存菜单
export function addOrUpdCd(data) {
  return request({
    url: '/sys/menu/edit',
    method: 'post',
    data
  })
}

// 删除菜单
export function delCd(data) {
  return request({
    url: '/sys/menu/del?id=' + data,
    method: 'post',
    // data
  })
}

// 部门树桩列表
export function bmListTree(query) {
  return request({
    url: '/sys/dept/listTree',
    method: 'get',
    params: query
  })
}

// 编辑部门/保存部门
export function addOrUpdBm(data) {
  return request({
    url: '/sys/dept/edit',
    method: 'post',
    data
  })
}

//删除部门
export function delBm(data) {
  return request({
    url: '/sys/dept/del',
    method: 'post',
    params: data
  })
}

//角色树状列表
export function jsListTree(query) {
  return request({
    url: '/sys/role/listPage',
    method: 'get',
    params: query
  })
}

//角色列表无分页
export function jsList(query) {
  return request({
    url: '/sys/role/lists',
    method: 'get',
    params: query
  })
}

// 查看成员-已添加用户
export function userLists(query) {
  return request({
    url: '/sys/roleUser/queryAddedUserByRoleIdPage',
    method: 'get',
    params: query
  })
}

// 查看成员-已添加用户-不分页
export function userListsRoleIds(query) {
  return request({
    url: '/sys/roleUser/queryAddedUserByRoleIds',
    method: 'get',
    params: query
  })
}

// 角色列表-不分页
export function listPageIds(query) {
  return request({
    url: '/sys/role/lists',
    method: 'get',
    params: query
  })
}

// 角色下全部用户
export function userAllLists(query) {
  return request({
    url: '/sys/roleuser/users',
    method: 'get',
    params: query
  })
}

// 角色分配部门反显
export function userInvert(query) {
  return request({
    url: '/sys/sysroledata/deptTree',
    method: 'get',
    params: query
  })
}

//获取部门树
export function userListPage(query) {
  return request({
    url: '/sys/dept/listTree',
    method: 'get',
    params: query
  })
}

// 成员列表
export function configurationMembers(query) {
  return request({
    url: '/sys/user/lists',
    method: 'get',
    params: query
  })
}

// 配置成员操作
export function configurationOperation(data) {
  return request({
    url: '/sys/roleuser/cfgUser',
    method: 'post',
    data
  })
}

//添加用户/编辑用户
export function addOrUpdUser(data) {
  return request({
    url: '/sys/user/edit',
    method: 'post',
    data
  })
}

//查询用户
export function finduserinfo(query) {
  return request({
    url: '/sys/user/info',
    method: 'get',
    params: query
  })
}

//修改用户状态
export function updYhzt(data) {
  return request({
    url: '/yx/user/changeStatus',
    method: 'post',
    data
  })
}

//修改系统用户状态
export function updsysYhzt(data) {
  return request({
    url: '/sys/user/changeStatus',
    method: 'post',
    data
  })
}

//重置密码
export function restartPwd(data) {
  return request({
    url: '/yx/user/reset',
    method: 'post',
    data
  })
}

//用户管理-重置密码
export function restartPwdUser(data) {
  return request({
    url: '/sys/user/resetPwd',
    method: 'post',
    data
  })
}

//用户管理-修改密码
export function changePasswd(data) {
  return request({
    url: '/base/personalCenter/changePasswd',
    method: 'post',
    data
  })
}

//用户管理-删除用户
export function delSystemUser(data) {
  return request({
    url: '/sys/user/del',
    method: 'post',
    params: data
  })
}

//用户管理-导出
export function downloadUser(params) {
  return request({
    url: '/sys/user/export',
    method: 'get',
    params
  })
}

//查询码表列表
export function mbglListPage(query) {
  return request({
    url: '/sys/webCode/listPage',
    method: 'get',
    params: query
  })
}

//查询码表数据
export function dataList(query) {
  return request({
    url: '/sys/webCode/dataListPage',
    method: 'get',
    params: query
  })
}

//新增码表数据/修改码表数据
export function addOrUpdData(data) {
  return request({
    url: '/sys/webCode/editData',
    method: 'post',
    data
  })
}

//
export function deptList(params) {
  return request({
    url: '/sys/dept/lists',
    method: 'get',
    params
  })
}

//删除码表数据
export function deleteData(data) {
  return request({
    url: '/sys/webCode/deleteData',
    method: 'post',
    data
  })
}

//查询码表结构
export function colList(query) {
  return request({
    url: '/sys/webCode/colListPage',
    method: 'get',
    params: query
  })
}

//新增码表/修改码表
export function addOrUpdMbgl(data) {
  return request({
    url: '/sys/webCode/edit',
    method: 'post',
    data
  })
}

//删除码表/修改码表
export function delMbgl(data) {
  return request({
    url: '/sys/webCode/dels',
    method: 'post',
    params: data
  })
}

//查询待新增的码表
export function tabList(query) {
  return request({
    url: '/sys/webCode/tabList',
    method: 'get',
    params: query
  })
}

//查询登录日志列表
export function fwjlListPage(query) {
  return request({
    url: '/sys/logLogin/listPage',
    method: 'get',
    params: query
  })
}

//删除登录日志
export function delFwjl(data) {
  return request({
    url: '/sys/logLogin/dels',
    method: 'post',
    params: data
  })
}

//查询操作日志列表
export function czjlListPage(query) {
  return request({
    url: '/sys/logAct/listPage',
    method: 'get',
    params: query
  })
}

//删除操作日志
export function delCzjl(data) {
  return request({
    url: '/sys/logAct/dels',
    method: 'post',
    params: data
  })
}


//更改文件下载状态
export function changeFile(data) {
  return request({
    url: '/sys/file/edit',
    method: 'post',
    data
  })
}

//删除文件
export function deleteFile(data) {
  return request({
    url: '/sys/file/dels',
    method: 'post',
    data
  })
}



//导出
export function exportUserList(query) {
  return request({
    url: '/sys/role/export',
    method: 'get',
    params: query
  })
}

//菜单导出
export function exportCdList(query) {
  return request({
    url: '/sys/menu/export',
    method: 'get',
    params: query
  })
}


// 定时任务列表
export function taskList(query) {
  return request({
    url: '/sys/schedulejob/listPage',
    method: 'get',
    params: query
  })
}

// 导出定时任务
export function exportTask(query) {
  return request({
    url: '/sys/schedulejob/export',
    method: 'get',
    params: query
  })
}

// 立即执行任务
export function implement(data) {
  return request({
    url: '/sys/schedulejob/run',
    method: 'post',
    data
  })
}

// 暂停定时任务
export function suspendTask(data) {
  return request({
    url: '/sys/schedulejob/pause',
    method: 'post',
    data
  })
}

// 恢复定时任务
export function recoveryTask(data) {
  return request({
    url: '/sys/schedulejob/pause',
    method: 'post',
    data
  })
}

// 删除定时任务
export function deleteTask(data) {
  return request({
    url: '/sys/schedulejob/dels',
    method: 'post',
    data
  })
}

// 新增编辑任务
export function addOrUpdTask(data) {
  return request({
    url: '/sys/schedulejob/edit',
    method: 'post',
    data
  })
}


// 系统用户列表
export function xtUserList(query) {
  return request({
    url: '/sys/user/listPage',
    method: 'get',
    params: query
  })
}

// 院系用户详情
export function yxUserInfo(query) {
  return request({
    url: '/yx/user/info',
    method: 'get',
    params: query
  })
}

// 编辑院系用户
export function editUser(data) {
  return request({
    url: '/yx/user/edit',
    method: 'post',
    data
  })
}

// 删除院系用户
export function deletUser(data) {
  return request({
    url: '/yx/user/dels',
    method: 'post',
    data
  })
}

// 导出院系用户
export function exportYxUser(query) {
  return request({
    url: '/yx/user/export',
    method: 'get',
    params: query
  })
}

// 定时任务日志列表
export function taskLogList(query) {
  return request({
    url: '/sys/schedulejoblog/listPage',
    method: 'get',
    params: query
  })
}

// 删除任务日志
export function deletTaskLog(data) {
  return request({
    url: '/sys/schedulejoblog/dels',
    method: 'post',
    data
  })
}


//学校管理列表
export function schoollist(query) {
  return request({
    url: '/sys/syssysxxxx/listPage',
    method: 'get',
    params: query
  })
}


// 编辑自定义学校/新增自定义学校
export function addOrUpdZdyXx(data) {
  return request({
    url: '/sys/syszdyxxxx/saveOrUpdate',
    method: 'post',
    data
  })
}


//修改系统学校是否使用
export function changeXxStaus(data) {
  return request({
    url: '/sys/syssysxxxx/updateSfsy',
    method: 'post',
    data
  })
}


//删除自定义学校
export function deleteZdyxx(data) {
  return request({
    url: '/sys/syszdyxxxx/dels',
    method: 'post',
    data
  })
}


//审核流程列表
export function shlcList(query) {
  return request({
    url: '/bs/process/listPage',
    method: 'get',
    params: query
  })
}

// 审核步骤列表
export function shbzList(query) {
  return request({
    url: '/bs/processStep/listPage',
    method: 'get',
    params: query
  })
}
//审核流程类型列表
export function processTypeList(params){
  return request({
    url:'/bs/processType/listPage',
    method:'get',
    params
  })
}
//全部审核流程类型
export function processTypeListAll(params){
  return request({
    url:'/bs/processType/lists',
    method:'get',
    params
  })
}
//编辑审核流程类型
export function processTypeEdit(data){
  return request({
    url:'/bs/processType/edit',
    method:'post',
    data
  })
}

//查询角色列表 --不分页
export function bzjsList(query) {
  return request({
    url: '/sys/role/lists',
    method: 'get',
    params: query
  })
}

//新增/编辑步骤
export function addOrUpBz(data) {
  return request({
    url: '/bs/processStep/edit',
    method: 'post',
    data: data
  })
}

//新增/编辑流程
export function addOrUpLc(data) {
  return request({
    url: '/bs/process/edit',
    method: 'post',
    data: data
  })
}

//新增客户
export function addkh(data) {
  return request({
    url: '/khgl/khkhxx/edit',
    method: 'post',
    data: data
  })
}

//我录入的客户列表
export function lrkhList(query) {
  return request({
    url: '/khgl/khkhxx/myLrListPage',
    method: 'get',
    params: query
  })
}

//产品管理-网络产品权益列表
export function qylist(query) {
  return request({
    url: '/cpgl/qyxx/lists',
    method: 'get',
    params: query
  })
}

//产品管理-产品数据列表
export function cpsjlist(query) {
  return request({
    url: '/cpgl/cpgl/listPage',
    method: 'get',
    params: query
  })
}


//客户管理-客户级别新增
export function addkhjb(data) {
  return request({
    url: '/xs/xskhjb/edit',
    method: 'post',
    data
  })
}

//客户管理-客户级别列表
export function kejblist(query) {
  return request({
    url: '/xs/xskhjb/listPage',
    method: 'get',
    params: query
  })
}


//查询当前角色公海池
export function userCustomerGroup(params) {
  return request({
    url: '/sys/RoleGhc/queryGhcsByRoleId',
    method: 'get',
    params
  })
}

//配置角色公海池
export function editUserCustomerGroup(data) {
  return request({
    url: '/sys/RoleGhc/cfgRoleGhcs',
    method: 'post',
    data
  })
}

//查询公海池对应用户
export function customerGroupUserList(params) {
  return request({
    url: '/khgl/khkhxx/queryUsersByGhc',
    method: 'get',
    params
  })
}

//转移公海池客户
export function changeCustomerGroup(data) {
  return request({
    url: '/khgl/khkhxx/fpghkh',
    method: 'post',
    data
  })
}

//首页-待办列表
export function myTodoList(params) {
  return request({
    url: '/task/sydbListPage',
    method: 'get',
    params
  })
}

//首页-跟进计划统计
export function myTaskCount(params) {
  return request({
    url: '/khgl/khgjjh/getGJtj',
    method: 'get',
    params
  })
}

//首页-待跟进计划列表
export function myTaskList(params) {
  return request({
    url: '/khgl/khgjjh/myDgjListPage',
    method: 'get',
    params
  })
}

//编辑自定义列
export function saveCustomDrage(data) {
  return request({
    url: '/base/query/save',
    method: 'post',
    data
  })
}

//查询自定义列
export function customDrageInfo(params) {
  return request({
    url: '/base/query/get',
    method: 'get',
    params
  })
}

// 查询首页分配选中值
export function getHomeInfo(params) {
  return request({
    url: '/sys/sysrolesymksz/symkList',
    method: 'get',
    params
  })
}

// 设置首页分配
export function setHomeInfo(data) {
  return request({
    url: '/sys/sysrolesymksz/cfgSymk',
    method: 'POST',
    data
  })
}

// 个人中心-我的消息列表
export function messageHomeList(data) {
  return request({
    url: '/xxtz/listPage',
    method: 'get',
    params: data
  })
}

// 个人中心-我的消息列表-单个已读
export function messageHomeRead(data) {
  return request({
    url: '/xxtz/read',
    method: 'POST',
    data
  })
}

// 个人中心-我的消息列表-单个删除
export function messageHomeDels(data) {
  return request({
    url: '/xxtz/dels',
    method: 'POST',
    data
  })
}

// 个人中心-我的消息列表-全部已读
export function allHaveRead(data) {
  return request({
    url: '/xxtz/allHaveRead',
    method: 'POST',
    data
  })
}

// 个人中心-我的消息列表-删除所有已读
export function delAllRead(data) {
  return request({
    url: '/xxtz/delAllRead',
    method: 'POST',
    data
  })
}

// 个人中心-我的消息列表-查询所有未读消息数量
export function getUnreadNums(data) {
  return request({
    url: '/xxtz/getUnreadNums',
    method: 'get',
    data
  })
}

// 查询用户资料
export function getPersonalInfo(params) {
  return request({
    url: '/base/personalCenter/info',
    method: 'get',
    params
  })
}

// 编辑资料
export function editInfo(data) {
  return request({
    url: '/base/personalCenter/editInfo',
    method: 'post',
    data
  })
}

// 编辑资料--手机号
export function editPhoneInfo(data) {
  return request({
    url: '/base/personalCenter/changePhone',
    method: 'post',
    data
  })
}

// 编辑资料---邮箱
export function editEmailInfo(data) {
  return request({
    url: '/base/personalCenter/changeEmail',
    method: 'post',
    data
  })
}

// 查询首页分配选中值
export function queryBaseLoginLogPage(params) {
  return request({
    url: '/base/personalCenter/queryBaseLoginLogPage',
    method: 'get',
    params
  })
}

//删除登录日志
export function delLoginLog(data) {
  return request({
    url: '/base/personalCenter/delBaseLoginLogs?ids=' + data.ids,
    method: 'post',
    data
  })
}

// 文件列表
export function fileList(query) {
  return request({
    url: '/sys/file/listPage',
    method: 'get',
    params: query
  })
}

//删除文件
export function delFile(data) {
  return request({
    url: '/sys/file/dels',
    method: 'post',
    params: data
  })
}

//禁止下载文件
export function changeDownStatus(data) {
  return request({
    url: '/sys/file/changeDownStatus',
    method: 'post',
    data
  })
}

//预览文件
export function previewfileFn(data) {
  return request({
    url: '/sys/file/previewfile',
    method: 'get',
    params: data,
    headers: {
      Accept: 'application/octet-stream'
    },
    responseType: "blob" // 表明返回服务器返回的数据类型
  })
}

//下载文件-导出
export function downloadFile(data) {
  return request({
    url: '/sys/file/download',
    method: 'post',
    params: data
  })
}

// 文件列表-导出
export function exportFile(data) {
  return request({
    url: '/sys/file/export',
    method: 'get',
    params: data
  })
}

// 下载文件
export function downloadFileFn(fid) {
  let host =
    process.env.NODE_ENV == "development"
      ? "https://demo.youuq.cn/single/sys/file/download"
      : "https://" + window.location.host + "/single/sys/file/download";
  return host;
}

// 预览文件
export function previewFileFn(fid) {
  let host =
    process.env.NODE_ENV == "development"
      ? "https://demo.youuq.cn/single/sys/file/previewfile"
      : "https://" + window.location.host + "/single/sys/file/previewfile";
  return host;
}

// 角色管理--待添加用户列表
export function notAddedUserByRoleIdPage(query) {
  return request({
    url: '/sys/roleUser/queryNotAddedUserByRoleIdPage',
    method: 'get',
    params: query
  })
}

// 角色管理--已添加用户列表
export function addedUserByRoleIdPage(query) {
  return request({
    url: '/sys/roleUser/queryAddedUserByRoleIdPage',
    method: 'get',
    params: query
  })
}

// 角色管理--添加用户
export function addUser(data) {
  return request({
    url: '/sys/roleUser/addUser',
    method: 'post',
    data
  })
}

// 角色管理--移除用户
export function delUser(data) {
  return request({
    url: '/sys/roleUser/delUser',
    method: 'post',
    data
  })
}

// 角色管理--数据权限-待添加用户列表
export function notAddedDeptByRoleIdPage(query) {
  return request({
    url: '/sys/roleMenuDept/queryNotAddedDeptByRoleIdAndMapperIdPage',
    method: 'get',
    params: query
  })
}

// 角色管理--数据权限-已添加用户列表
export function alladdedDeptByRoleIdPage(query) {
  return request({
    url: '/sys/roleMenuDept/queryAddedDeptByRoleIdAndMapperIdPage',
    method: 'get',
    params: query
  })
}

// 角色管理--数据权限-添加用户
export function addMenuDept(data) {
  return request({
    url: '/sys/roleMenuDept/addMenuDept',
    method: 'post',
    data
  })
}

// 角色管理--数据权限-移除用户
export function delMenuDept(data) {
  return request({
    url: '/sys/roleMenuDept/delMenuDept',
    method: 'post',
    data
  })
}

// 角色树桩列表
export function roleListTree(query) {
  return request({
    url: '/sys/roleMenu/menuTree',
    method: 'get',
    params: query
  })
}


// 系统用户列表-不分页列表
export function allUserList(query) {
  return request({
    url: '/sys/user/lists',
    method: 'get',
    params: query
  })
}

// 删除流程
export function deltelc(query) {
  return request({
    url: '/bs/process/trash?id=' + query.id,
    method: 'post'
  })
}
//强制删除流程
export function forceDeleteProcess(params){
  return request({
    url:'/bs/process/forcedTrash',
    method:'post',
    params
  })
}

// 删除步骤
export function deltebz(query) {
  return request({
    url: '/bs/processStep/del?id=' + query.id,
    method: 'post'
  })
}

// 删除角色
export function delteRole(query) {
  return request({
    url: '/sys/role/del?id=' + query,
    method: 'post'
  })
}

// 取消删除角色
export function cancelDelteRole(query) {
  return request({
    url: '/sys/role/cancelDel?id=' + query,
    method: 'post'
  })
}
// 获取定时任务token
export function timeTaskToken(params){
  return request({
    url:'/sys/menu/queryXxlJobCookie',
    method:'get',
    params
  })
}
